import { Case } from 'src/app-client/_appCommon/base/Case';
import { CaseStage, Product, Status } from 'src/app-admin/_appCommon/base/AppInterfaceAndBaseClasses';
import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class StatusManagerService
{
  public nextStatus: Status;
  public beforeStatus: Status;
  public currentStatus: Status;

  public _statusList: Status[];
  private _currentCase: Case;
  private _currentProduct: Product;
  private _currentCaseStage: CaseStage;

  constructor()
  {

  }

  public setCurrentCase(currentCase: Case): void
  {
    this._currentCase = currentCase;
  }

  public setCurrentCaseStage(currentCaseStage: CaseStage): void
  {
    this._currentCaseStage = currentCaseStage;
    this.setCurrentStatus();
  }

  public setStatusInfo(statusList: Status[]): void
  {
    this._statusList = statusList;
    this.setCurrentStatus();
  }

  public getStatusInfo(): Status[]
  {
    return this._statusList;
  }

  public setProductInfo(product: Product): void
  {
    this._currentProduct = product;
  }

  private setCurrentStatus(): void
  {
    if(this._currentCaseStage)
    {
      this.currentStatus = this._statusList.find(x => x.id == this._currentCaseStage.statusId);
      this.beforeStatus = this._statusList.find(x => x.order == this.currentStatus.order-1);
      this.nextStatus = this._statusList.find(x => x.order == this.currentStatus.order+1);
    }
  }

  public showNextStatusButton(): boolean
  {
    if (this._currentCase)
    {
      let lastStatus = this._statusList[this._statusList.length-1];
      return this._currentCaseStage?.stageNumber != lastStatus.order;
    }
  }

  public validateNextStatus(): [boolean, string]
  {
    // RequiresSetupPayment
    if(this.nextStatus.requiresSetupPayment && !this._currentProduct?.setupIncluded)
    {
      return [false, `Para poder continuar con el estatus: "${this.nextStatus.name}" es necesario el pago del Setup`];
    }

    // RequiresSufficientAlignersAvailable
    if (this.nextStatus.requiresSufficientAlignersAvailable)
    {
      if(!this._currentProduct.hasUnlimitedAligners && this._currentCaseStage.totalAlignersQuantity > this._currentCase.remainingAligners)
      {
        return [false, `Para poder continuar con el estatus: "${this.nextStatus.name}" es necesario tener alineadores suficientes`];
      }
    }

    return [true, ''];
  }
}
